import type { PayloadSnapshot, Row, ViewState } from './types'
import { isLimbo } from './aggregate'

type LanePayload = Pick<PayloadSnapshot, 'own_grace' | 'redate_slips' | 'stale_days'>

export function laneTest(lane: string, row: Row, state: Pick<ViewState, 'since'>, payload: LanePayload): boolean {
  switch (lane) {
    case 'intake':
      return row.entered_days !== null && row.entered_days <= Number(state.since)
    case 'score':
      return row.open && row.src === 'missing'
    case 'cat':
      return row.open && !row.cat
    case 'own':
      return row.open && !row.assignee && (row.entered_days === null || row.entered_days > payload.own_grace)
    case 'redate':
      return row.open && row.due_status === 'overdue' && row.due_slips >= payload.redate_slips
    case 'limbo':
      return isLimbo(row, payload.stale_days)
    default:
      return false
  }
}

export function laneRows(rows: Row[], lane: string, state: Pick<ViewState, 'since'>, payload: LanePayload): Row[] {
  return rows.filter((row) => laneTest(lane, row, state, payload))
}

export function applyLane(state: ViewState, lane: ViewState['lane']): ViewState {
  return {
    ...state,
    scope: 'all', stage: 'any', due: 'any', idle: 'any', score: 'any', owner: 'any',
    cat: 'any', catsrc: 'any', duemove: 'any', pri: 'any', lane, expand: 'all',
  }
}
